import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Typography, Box } from '@material-ui/core';
import MuiLink from '@material-ui/core/Link';
import { useStyles } from './styles';
import { ReactComponent as LanguageIcon } from './assets/language.svg';
import { AudioPlayer } from '../../../../shared/audioPlayer';
import { ReactComponent as PreviewIcon } from './assets/previewIcon.svg';
import { ExerciseCardProps } from './interface';
import useApi from '../../../../shared/hook/useApi';
import { topicIcons } from '../../../../shared/filters/assets';
import ChipList from '../../../../shared/chip-list';

const ExerciseCard: FC<ExerciseCardProps> = ({ content }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [audioPlayed] = useApi('audioPlayed');

  const onPlay = () => {
    audioPlayed({
      type: 'exercise',
      name: content.name,
      language: content.language,
      topic: content.audiotopic,
    });
  };

  return (
    <Box className={classes.wrapper}>
      <Card className={classes.root}>
        <Box className={classes.cardHeader}>
          <ChipList
            list={[t(`v2.global.chip_label_topic_${content.audiotopic}`)]}
            style={{ margin: 0 }}
          />
        </Box>
        <CardContent className={classes.cardContent}>
          <Box className={classes.cardDescription}>
            <Box className={classes.exerciseIcon}>
              {topicIcons?.[content.audiotopic] ?? topicIcons.default}
            </Box>

            <Box className={classes.descriptionContent}>
              <Typography className={classes.descriptionTitle}>
                {content.name}
              </Typography>
              <Typography> {content.description} </Typography>
            </Box>
          </Box>
          <Box className={classes.languageWrapper}>
            <LanguageIcon />
            <Typography component="span" className={classes.language}>
              {t(`Language.${content.language}`)}
            </Typography>
          </Box>
        </CardContent>
        <AudioPlayer url={content.audio} onPlay={onPlay} />
      </Card>
      <Box className={classes.pdfPreviewWrapper}>
        <Box className={classes.linkContainer}>
          <MuiLink
            className={classes.linkLabel}
            variant="body1"
            underline="none"
            href={content.pdf}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(
              'v2.exercises.section_audioExercises_card_button_viewExerciseSheet',
            )}
          </MuiLink>
          <Typography component="span" className={classes.previewIcon}>
            <PreviewIcon />
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ExerciseCard;
